import { createIcon } from "../create-icon"

export const MinusIcon = createIcon({
  title: "MinusIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      d="M12 8L4 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  ),
})

MinusIcon.displayName = "MinusIcon"
